const muiFormControlLabel = {
  styleOverrides: {
    labelPlacementEnd: {
      marginLeft: -7,
    },
  },
};

export default muiFormControlLabel;
